/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IKrannichCNewsletterViewProps } from './krannich-c-newsletter';

export default (props: IKrannichCNewsletterViewProps) => {
    const {
        config: { heading, subheading, formUrl },
        resources: { submit, validAddressError, newsletterEmailLabel }
    } = props;

    const [emailAddress, setEmailAddress] = React.useState('');
    const [isDisabled, setIsDisabled] = React.useState(true);
    const [fieldError, setFieldError] = React.useState('');

    const mainClassName = 'news-letter_';

    const handlerEmailAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmailAddress(e.target.value);
    };
    const validateEmail = (email: string) => {
        if (
            String(email)
                .toLowerCase()
                .match(
                    // eslint-disable-next-line security/detect-unsafe-regex
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
        ) {
            setFieldError('');
            return true;
        } else {
            setFieldError(validAddressError);
            setIsDisabled(true);
            return false;
        }
    };
    React.useEffect(() => {
        if (emailAddress === '') {
            setIsDisabled(true);
            setFieldError('');
        } else {
            if (emailAddress.length > 10 && validateEmail(emailAddress)) {
                setIsDisabled(false);
                setFieldError('');
            } else {
                setIsDisabled(true);
            }
        }
    }, [emailAddress]);

    return (
        <div className='row'>
            <div className={`${mainClassName}contianer`}>
                <div className={`${mainClassName}info-contianer`}>
                    <div className={`${mainClassName}icon-contianer`}>
                        <span className={`${mainClassName}icon`}></span>
                    </div>
                    <div className={`${mainClassName}title-contianer`}>
                        <h3 className={`${mainClassName}heading`}>{heading}</h3>
                        <h4 className={`${mainClassName}subtitle`}>{subheading}</h4>
                    </div>
                </div>
                <div className={`${mainClassName}action-contianer`}>
                    <label className='sr-only' htmlFor='new-letter-input' title='newsletter input'>
                        {newsletterEmailLabel}
                    </label>
                    <input
                        type='email'
                        id='new-letter-input'
                        placeholder='Your Email Address...'
                        onChange={handlerEmailAddress}
                        onBlur={e => {
                            validateEmail(e.target.value);
                        }}
                        value={emailAddress}
                        className={`${mainClassName}email-field`}
                    />
                    <a
                        href={`${formUrl?.trim()}?Email=${emailAddress}`}
                        className={`${mainClassName}btn-submit ${isDisabled ? 'submit-disable' : ''}`}
                    >
                        {submit}
                    </a>
                    {<p className='error'>{fieldError}</p>}
                </div>
            </div>
        </div>
    );
};
